import React, { useEffect, useState } from 'react'
// Components
import { Text } from 'components/Text/Text'
// Styles
import {
  ModalRoot,
  ModalContainer,
  ModalClose,
  ModalTitle,
} from './Modal.styled'
import { ModalProps } from './Modal.props'
import { useKeypress } from 'hooks/use-keypress'

export const Modal = ({
  children,
  rootStyle,
  containerStyle,
  typeModal,
  showClose = true,
  title,
  onClose,
}: ModalProps) => {
  const [esc, setEsc] = useState(false)
  useKeypress('Escape', () => setEsc(true))
  useEffect(() => {
    if (showClose && esc && onClose) {
      setEsc(false)
      onClose()
    }
  }, [esc, showClose, onClose])
  return (
    <ModalRoot style={rootStyle} as={typeModal} onClick={onClose}>
      <ModalContainer style={containerStyle} onClick={e => e.stopPropagation()}>
        {title && <ModalTitle>{title}</ModalTitle>}
        {showClose && (
          <ModalClose>
            <Text preset="small" className="close" onClick={onClose}>
              x
            </Text>
          </ModalClose>
        )}
        {children}
      </ModalContainer>
    </ModalRoot>
  )
}

export default Modal
